var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.4706 22 22 17.4608 22 12C22 6.52941 17.4608 2 11.9902 2C6.52941 2 2 6.52941 2 12C2 17.4608 6.53922 22 12 22ZM10.8922 16.7941C10.5588 16.7941 10.2843 16.6569 10.0294 16.3137L7.56863 13.2941C7.42157 13.098 7.33333 12.8824 7.33333 12.6569C7.33333 12.2157 7.67647 11.8529 8.11765 11.8529C8.40196 11.8529 8.61765 11.9412 8.86274 12.2647L10.8529 14.8333L15.0392 8.10784C15.2255 7.81373 15.4804 7.65686 15.7353 7.65686C16.1667 7.65686 16.5686 7.95098 16.5686 8.41176C16.5686 8.62745 16.4412 8.85294 16.3235 9.05882L11.7157 16.3137C11.5098 16.6373 11.2255 16.7941 10.8922 16.7941Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circleCheck.38c8fcc16f6842eb1ae4afdff734999d.svg";
export { ForwardRef as ReactComponent };